import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FAQ_CATEGORY_SLUGS from '../faqCategorySlugs';
import './FAQ.css';

function FAQ() {
  const { t } = useTranslation();
  const location = useLocation();
  // Welke vraag(en) opengeklapt staan, bijgehouden per "categorie-index_item-
  // index" sleutel (bv. "0_2"), zodat meerdere vragen tegelijk open kunnen
  // staan zonder dat items uit verschillende categorieën botsen.
  const [openKeys, setOpenKeys] = useState(new Set());

  useEffect(() => {
    document.title = 'SmartStays - Veelgestelde vragen';
  }, []);

  // Springt naar de juiste categorie-sectie wanneer je via de Navbar-
  // dropdown op een specifiek thema klikt (bv. /faq#schoonmaak), met een
  // kleine offset zodat de sticky navbar de titel niet overlapt.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }, 80);
    return () => clearTimeout(timer);
  }, [location.hash]);

  // Maar 1 vraag tegelijk open: een andere vraag openklikken sluit de vorige.
  const toggle = (key) => {
    setOpenKeys((prev) => (prev.has(key) ? new Set() : new Set([key])));
  };

  const categories = t('faq.categories', { returnObjects: true });

  return (
    <div className="faq-container">
      <Navbar />

      <section className="faq-hero">
        <h1>{t('faq.title')}</h1>
        <p className="faq-subtitle">{t('faq.subtitle')}</p>
      </section>

      <div className="faq-content">
        {categories.map((category, catIndex) => (
          <section className="faq-category" id={FAQ_CATEGORY_SLUGS[catIndex]} key={catIndex}>
            <h2 className="faq-category-title">{category.title}</h2>

            <div className="faq-list">
              {category.items.map((item, itemIndex) => {
                const key = `${catIndex}_${itemIndex}`;
                const isOpen = openKeys.has(key);
                return (
                  <div className={`faq-item ${isOpen ? 'open' : ''}`} key={key}>
                    <button
                      type="button"
                      className="faq-question"
                      onClick={() => toggle(key)}
                      aria-expanded={isOpen}
                    >
                      <span>{item.q}</span>
                      <svg
                        className="faq-chevron"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>

                    {isOpen && (
                      <div className="faq-answer">
                        {(item.a || []).map((paragraph, i) => (
                          <p key={i}>{paragraph}</p>
                        ))}

                        {item.list && (
                          <ul className="faq-answer-list">
                            {item.list.map((li, i) => (
                              <li key={i}>{li}</li>
                            ))}
                          </ul>
                        )}

                        {item.listItems && (
                          <ul className="faq-answer-list faq-answer-list-titled">
                            {item.listItems.map((li, i) => (
                              <li key={i}>
                                <strong>{li.title}</strong>
                                <span>{li.text}</span>
                              </li>
                            ))}
                          </ul>
                        )}

                        {item.aAfter && item.aAfter.map((paragraph, i) => (
                          <p key={`after-${i}`}>{paragraph}</p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>

      <Footer />
    </div>
  );
}

export default FAQ;
